import FormErrors from "@/components/FormErrors/FormErrors";
import { JSConn } from "@/utilities/js-conn";
import uuidv4 from "uuid/v4";
import { last as Rlast } from "ramda";
import VueScrollTo from "vue-scrollto";

export default {
  name: "templateWorkOrderTaskEditForm",
  props: {
    templateWorkOrderTaskId: String,
  },
  components: {
    FormErrors,
  },
  data() {
    return {
      hasTaskErrors: false,
      taskErrors: [],
      task: {
        id: "",
        name: "",
        description: "",
      },
    };
  },
  created() {
    const STEP_SIZE = 200;
    let lastTask = Rlast(this.templateWorkOrderTasks);

    // for the situations when there isn't a last task
    if (!lastTask) {
      lastTask = {
        sort_order: 0,
      };
    }

    if (this.templateWorkOrderTaskId === "new") {
      this.task = {
        id: uuidv4(),
        name: "New",
        description: null,
        sort_order: lastTask.sort_order + STEP_SIZE,
        template_work_order_id: this.templateWorkOrder.id,
      };
    } else {
      // load the task into the store
      // or retrieve it
      const woTask = this.templateWorkOrderTaskById(
        this.templateWorkOrderTaskId,
      );
      this.task = {
        id: woTask.id,
        name: woTask.name,
        description: woTask.description,
        sort_order: woTask.sort_order,
      };
    }

    this.$nextTick(() => {
      VueScrollTo.scrollTo("#top-target");
      this.$refs.firstInput.select();
    });
  },
  computed: {
    templateWorkOrder: function() {
      return this.$store.getters.templateWorkOrder;
    },
    templateWorkOrderTasks: function() {
      return this.$store.getters.templateWorkOrderTasks;
    },
    templateWorkOrderTaskById: function() {
      return id => this.$store.getters.templateWorkOrderTaskById(id);
    },
  },
  methods: {
    submitTaskForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();

      let storeDispatch;

      if (this.templateWorkOrderTaskId === "new") {
        storeDispatch = "createTemplateWorkOrderTask";
      } else {
        storeDispatch = "updateTemplateWorkOrderTask";
      }

      jsConn.formParams = this.task;

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          // move to the list of tasks
          this.$router.push({
            name: "templateWorkOrderTasks",
          });
          // load the work order again
          this.$emit("templateTasksChanged");
        })
        .catch(jsConn => {
          this.hasTaskErrors = true;
          this.taskErrors = jsConn.error["response"]["data"];
        });
    },
  },
};
